import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";

import { limpaTituloCurso } from "../../../../utils/Utils";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/Parceiros/Pedidos/Back";
import Loading from "../../../../components/Loader";

import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  Select,
  ContainerPaginate,
  FilterSelect,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import { isAuthAdmin } from "../../../../services/auth";

const GerenciarCursosPersonalite = () => {
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [cursos, setCursos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filterAtivo, setFilterAtivo] = useState("S");

  const [optionsCategorias, setOptionsCategorias] = useState([]);

  useEffect(() => {
    setLoading(true);
    api
      .get(
        `/cursos-filter-columns?filter=${search}&page=${page}&columns=id,id_categorias_personalite,curso&ativo=${filterAtivo}`
      )
      .then((response) => {
        if (response.data) {
          setCursos(response.data.cursos);
          setTotalPaginas(response.data.paginas);
        } else {
          alert(response.message);
        }

        setLoading(false);
      })
      .catch((err) => console.error(err));
  }, [search, page, filterAtivo]);

  useEffect(() => setPage(1), [search]);

  useEffect(() => {
    api
      .get("/categories-personalite")
      .then((response) => {
        setOptionsCategorias(response.data.categories);
      })
      .catch((err) => console.error(err));
  }, []);

  const changePage = (e) => {
    const paged = e.target.innerHTML;

    if (paged === "»") {
      setPage(totalPaginas);
    } else if (paged === "«") {
      setPage(1);
    } else if (paged === "⟩") {
      setPage((itself) => itself++);
    } else if (paged === "⟨") {
      setPage((itself) => itself--);
    } else {
      setPage(paged);
    }
  };

  const updateCategoria = (e, idCurso) => {
    const data = {
      idCategorie: parseInt(e.target.value),
      idCurso: idCurso,
    };
    api
      .put("/admin/curso-categories-personalite", data, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((response) => {
        if (response.data) {
          let logs = {
            local: "Personalite/GerenciarCursos",
            texto: `editou a categoria personalite (${response.data.id})`,
          };
          api.post("system_logs", { acao: JSON.stringify(logs) });
          swal({
            title: "Alteração realizada com sucesso!",
            text: `Você alterou a Categoria Personalite do curso ${limpaTituloCurso(
              response.data.curso
            )} para a categoria ${
              optionsCategorias[response.data.id_categorias_personalite - 1]
                .name
            }`,
            icon: "success",
            button: "Ok !",
          });
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title> Gerencimento das Catergorias Personalite dos Cursos</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Filtrar Cursos"
              value={search}
              onChange={(e) => setSearch(e.target.value || "")}
            />
            <Icon name="search icon" />
            <FilterSelect
              defaultValue={"S"}
              onChange={(e) => setFilterAtivo(e.target.value)}
            >
              <option value={"S"}>Cursos Ativos</option>
              <option value={"N"}>Cursos Inativos</option>
              <option value={""}> Todos os cursos </option>
            </FilterSelect>
          </ContainerInputSearch>
          {loading ? (
            <div>
              <Loading />
            </div>
          ) : (
            <>
              <SemanticTable size="big" celled>
                <SemanticTable.Header>
                  <SemanticTable.Row>
                    <SemanticTable.HeaderCell> ID </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell> Curso </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>
                      Categorias Personalite
                    </SemanticTable.HeaderCell>
                  </SemanticTable.Row>
                </SemanticTable.Header>
                <SemanticTable.Body>
                  {cursos?.map((curso, index) => (
                    <SemanticTable.Row key={index}>
                      <SemanticTable.Cell>{curso.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{curso.curso}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {optionsCategorias ? (
                          <Select
                            onChange={(e) => updateCategoria(e, curso.id)}
                            dafaultValue={curso.id_categorias_personalite}
                          >
                            <option value={0} selected>
                              Escolha uma categoria
                            </option>
                            {optionsCategorias.map((categoria, key) =>
                              categoria.id ===
                              curso.id_categorias_personalite ? (
                                <option key={key} value={categoria.id} selected>
                                  {categoria.name}
                                </option>
                              ) : (
                                <option key={key} value={categoria.id}>
                                  {categoria.name}
                                </option>
                              )
                            )}
                          </Select>
                        ) : null}
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
                </SemanticTable.Body>
              </SemanticTable>

              <ContainerPaginate>
                <Pagination
                  boundaryRange={0}
                  defaultActivePage={1}
                  ellipsisItem={null}
                  siblingRange={1}
                  totalPages={totalPaginas}
                  onPageChange={(e) => changePage(e)}
                />
              </ContainerPaginate>
            </>
          )}
        </Content>
      </Container>
    </>
  );
};

export default withRouter(GerenciarCursosPersonalite);
